import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormatCurrencyModule } from '@shared/format-currency/format-currency.module';
import { CommissionRequestSummaryComponent } from './commission-request-summary.component';

@NgModule({
  declarations: [
    CommissionRequestSummaryComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatProgressSpinnerModule,
    FormatCurrencyModule
  ],
  exports: [
    CommissionRequestSummaryComponent
  ]
})
export class CommissionRequestSummaryModule { }
